import { render } from "./FileVideo.vue?vue&type=template&id=12d31940&scoped=true&ts=true"
import script from "./FileVideo.vue?vue&type=script&lang=ts"
export * from "./FileVideo.vue?vue&type=script&lang=ts"

import "./FileVideo.vue?vue&type=style&index=0&id=12d31940&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d31940"]])

export default __exports__